import { useCallback, useEffect, useState } from 'react';
import useIsMounted from '../../shared/hooks/useIsMounted';
import { useSearchParams } from 'react-router-dom';
import { fetchWithAuth } from '../auth/fetchWithAuth';
import buildAdminTasksQuery from './buildAdminTasksQuery';
import { API_URL } from '../../config/env';

export default function useAdminTasks() {
  const isMounted = useIsMounted();
  const [searchParams] = useSearchParams();
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);

  const queryString = searchParams.toString();

  const refresh = useCallback(async () => {
    try {
      const qs = buildAdminTasksQuery(queryString);
      const res = await fetchWithAuth(`${API_URL}/v1/admin/tasks?${qs}`);
      if (!res.ok) throw new Error('Failed to load tasks');
      const json = await res.json();
      setData(json);
      setError(null);
    } catch (err) {
      if (!isMounted.current) return;
      console.error('Error loading tasks:', err);
      setError(err);
    }
  }, [queryString, isMounted]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { data, error, refresh };
}
